import React, { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function LogoUploader({ value, onChange, label = "Logo", testid = "logo" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Vennligst velg en bildefil");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.path);
      toast.success("Logo lastet opp");
    } catch (e) {
      toast.error("Opplasting feilet");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-16 h-16 border border-neutral-200 bg-neutral-50 flex items-center justify-center overflow-hidden">
        {value ? (
          <img src={fileUrl(value)} alt={label} className="w-full h-full object-contain" />
        ) : (
          <ImageIcon className="w-6 h-6 text-neutral-400" />
        )}
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-1">{label}</div>
        <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testid}-input`} />
        <Button
          type="button"
          variant="outline"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="rounded-sm"
        >
          <Upload className="w-4 h-4 mr-2" />
          {busy ? "Laster opp…" : value ? "Bytt logo" : "Last opp logo"}
        </Button>
      </div>
    </div>
  );
}
